import styled from 'styled-components';
import { Footer as LiteFooter } from '@curtin-dxp/ui';

export const Footer = styled(LiteFooter)`
  grid-area: footer;
  @media print {
    display: none;
  }
`;